// settings
export const TOGGLE_SETTINGS = 'TOGGLE_SETTINGS';
export const TOGGLE_LOADING_SCREEN = 'TOGGLE_LOADING_SCREEN';
export const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';
export const SET_STAGE_DIMENSIONS = 'SET_STAGE_DIMENSIONS';
